import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import { FaInstagram, FaTwitter, FaGithub, FaLinkedin } from "react-icons/fa";
import { SiLeetcode, SiGmail } from "react-icons/si";
import emailjs from '@emailjs/browser';
import axios from "axios";
import "./Contact.css";

const Contact = () => {
  const [, setVisitorCount] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmitMessage = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const currentTime = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      });

      await emailjs.send(
        'service_1c792lh',
        'template_31qo3rl',
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
          current_time: currentTime
        },
        'zIlWeRz3E7hWhV1qk'
      );
      
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => {
        setSubmitStatus('');
      }, 3000);
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
  };

  const socialLinks = [
    {
      name: "Instagram",
      icon: <FaInstagram />,
      url: "https://instagram.com/your_username",
      color: "#E4405F",
    },
    {
      name: "Twitter",
      icon: <FaTwitter />,
      url: "https://x.com/nikhilNegiENV",
      color: "#1DA1F2",
    },
    {
      name: "GitHub",
      icon: <FaGithub />,
      url: "https://github.com/Nikhil-Negi-tech",
      color: "black",
    },
    {
      name: "LeetCode",
      icon: <SiLeetcode />,
      url: "https://leetcode.com/u/Nikhil_Negi/",
      color: "#FFA116",
    },
    {
      name: "LinkedIn",
      icon: <FaLinkedin />,
      url: "https://www.linkedin.com/in/nikhil-negi-00566126a/",
      color: "#0077B5",
    },
    {
      name: "Gmail",
      icon: <SiGmail />,
      url: "https://mail.google.com/mail/?view=cm&fs=1&to=neginikhilsingh6@gmail.com",
      color: "#EA4335",
    },
  ];

  useEffect(() => {
    axios
      .get("https://portfolio-visitor-count-qvpc.onrender.com/api/visitor")
      .then((res) => {
        setVisitorCount(res.data.count);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <Element name="contact">
      <section className="contact">
        <video autoPlay loop muted playsInline className="contact-bg-video">
          <source src="hero.mp4" type="video/mp4" />
        </video>

        <div className="contact-container">
          <h2 className="section-title" style={{ color: "white" }}>
            Get In Touch
          </h2>
          <p className="contact-description">
            Let's connect and explore opportunities together!
          </p>
          <div className="social-links">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                style={{ "--hover-color": social.color }}
                data-aos="fade-right"
                data-aos-delay={index * 100}
              >
                <div className="social-icon">{social.icon}</div>
                <span>{social.name}</span>
              </a>
            ))}
          </div>

          {/* Contact Form */}
          <div className="contact-form-container">
            <h3 className="form-title">Send me a message</h3>
            <form onSubmit={handleSubmitMessage} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Your full name"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="your@email.com"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message</label>                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Your message here..."
                    rows="4"
                    required
                  />
              </div>
              
              <button 
                type="submit" 
                className="form-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
              
              {submitStatus === 'success' && (
                <div className="status-message success">
                  Message sent successfully! I'll get back to you soon. ✅
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="status-message error">
                  Failed to send message. Please try again. ❌
                </div>
              )}
            </form>
          </div>
          <div className="contact-footer">
            <p>© 2025 Nikhil Negi - Built with passion and code</p>
            {/* <div className="visitor-counter">👁️ Visitors: {visitorCount}</div> */}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Contact;
